//TODO::导入vue
import Vue from 'vue';
//TODO::导入网络组件
import Api from './api';
//TODO::导入vue主视图
import App from './App';
//TODO::导入vuex
import store from './vuex';
//TODO::导入vue路由
import router from './router';
//TODO::图片懒加载
import VueLazyload from 'vue-lazyload';
//TODO::导入工具文件
import './common';
//TODO::导入全局公共样式
import './assets/index.less';
//TODO::导入icon
import './icons'; // 用法：<svg-icon icon-class="loading" />
//TODO::引入echarts图表工具
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
//TODO::引入ElementUI
import ElementUI from 'element-ui';
import '../theme/index.css'; // 引入element自定义主题
// import 'element-ui/lib/theme-chalk/index.css';
// import './assets/iconfont/iconfont.css';
import Mixin from './mixins'; //全局混入
Vue.mixin(Mixin);
Vue.use(ElementUI);

Vue.use(Api);

// TODO:图片懒加载配置，文档：https://github.com/hilongjw/vue-lazyload
const errorimage = require('../static/images/errorimage.png')
const loadimage = require('../static/images/loadimage.png')

Vue.use(VueLazyload, {
  attempt: 1,
  lazyComponent: true,
  error: errorimage,//图片路径错误时加载图片
  loading: loadimage,//预加载图片
});

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js